import React, { useEffect, useRef, useState } from 'react';
import 'grapesjs/dist/css/grapes.min.css';
import grapesjs from 'grapesjs';
import { apiUrl, pageUrl, protocol } from '../../utils/url';
import { useSelector } from 'react-redux';
import LinkEditorModal from './link-editor-modal';
import ReactDOM from 'react-dom';
import NewSideBar, { creditsUsageJSX } from '../../components/side-bar/new-sidebar';
import PageHeader from '../../components/page-header';
import { toast } from 'react-toastify';
import customCodePlugin from 'grapesjs-custom-code';

const GrapeJs = (props) => {
    const { productData, iframeURL, iframeIndex, productSlug, campaign_id } = props;
    const editorRef = useRef(null);
    const { slug } = useSelector((state) => state?.slugReducer);
    const variables = useSelector(state => state?.variablesReducer);

    useEffect(() => {
        grapesjs.plugins.add('link-editor', (editor, options = {}) => {
            editor.Commands.add("open-link-editor", {
                run: (editor, sender, data = {}) => {
                    data.component = data.component || editor.getSelected();

                    editor.Modal
                        .setTitle("Edit Link")
                        .setContent('<div id="modalContentContainer"></div>')
                        .open();

                    ReactDOM.render(
                        <LinkEditorModal
                            data={data}
                            options={options}
                            editor={editor}
                            onSave={() => editor.Modal.close()}
                            onClose={() => editor.Modal.close()}
                        />,
                        document.getElementById('modalContentContainer')
                    );
                }
            });

            const linkType = editor.DomComponents.getType('link');
            editor.DomComponents.addType('link', {
                model: linkType.model,
                view: linkType.view.extend({
                    events: {
                        "dblclick": "editLink"
                    },
                    editLink(e) {
                        e.stopImmediatePropagation();
                        editor.runCommand("open-link-editor", { component: this.model });
                    }
                })
            });

            const linkRTEAction = editor.RichTextEditor.remove('link');
            if (linkRTEAction) {
                linkRTEAction.result = (rte) => {
                    rte.exec('createLink', '__new__');
                    editor.getSelected().view.disableEditing();

                    const linkComponents = getAllComponents().filter(component => (component.get('attributes').href || '') === '__new__');
                    if (linkComponents.length > 0) {
                        const linkComponent = linkComponents[0];
                        const attributes = linkComponent.get("attributes");
                        attributes.href = '';
                        linkComponent.set('attributes', attributes);

                        editor.runCommand("open-link-editor", { component: linkComponent });
                    } else {
                        console.error('Could not find inserted link');
                    }
                };
                editor.RichTextEditor.add('link', linkRTEAction);
            }

            function getAllComponents(component = editor.DomComponents.getWrapper()) {
                let components = component.get("components").models;
                component.get("components").forEach((comp) => {
                    components = components.concat(getAllComponents(comp));
                });
                return components;
            }
        });

        const editor = grapesjs.init({
            showOffsets: 1,
            noticeOnUnload: 0,
            container: '#gjs',
            height: '100%',
            fromElement: true,
            plugins: ['link-editor',customCodePlugin ],
            pluginsOpts: {
                'link-editor': {
                    links: [
                        {
                            category: "Search Engines",
                            links: [
                                { value: "http://google.com", label: "Google" },
                                { value: "http://bing.com", label: "Bing" }
                            ]
                        }
                    ]
                },
                [customCodePlugin]: {
                    buttonLabel: "Save Changes",
                },
            },
            undoManager: {
                trackSelection: true
            },
            storageManager: {
                type: 'local',
                autosave: true,
                autoload: false,
                stepsBeforeSave: 1,
                onStore: handleSave,
                onLoad:handleLoad,
                contentTypeJson: true,
                storeComponents: true,
                storeStyles: true,
                storeHtml: true,
                storeCss: true,
            },
            layerManager: {
                appendTo: '.panel__left'
            },
            styleManager: {
                // appendTo: '.panel__right',
                sectors: [
                    { name: 'General', open: false, buildProps: ['display'] },
                    { name: 'Flex', open: false, buildProps: ['flex-direction', 'flex-wrap', 'justify-content', 'align-items', 'align-content', 'gap'] },
                    // { name: 'Grid', open: false, buildProps: ['grid-template-columns'] },
                    { name: 'Dimension', open: false, buildProps: ['width', 'height', 'max-width', 'min-height', 'margin', 'padding'] },
                    { name: 'Typography', open: false, buildProps: ['font-family', 'font-size', 'font-weight', 'letter-spacing', 'color', 'line-height', 'text-shadow' , 'text-align', 'text-decoration'],
                        properties: [{
                            name: 'Font',
                            property: 'font-family',
                            type: 'select',
                            default: productData?.branding?.font ? JSON?.parse(productData?.branding?.font)?.value : "GT Walsheim Pro, sans-serif",
                            options: [
                              { value: "GT Walsheim Pro, sans-serif", name: 'GT Walsheim Pro' },
                              { value: 'Arial, Helvetica, sans-serif', name: 'Arial' },
                              { value: 'Arial Black, Helvetica, sans-serif', name: 'Arial Black' },
                              { value: 'Helvetica, sans-serif', name: 'Helvetica' },
                              { value: 'Times New Roman, serif', name: 'Times New Roman' },
                              { value: 'Courier New, Courier, monospace', name: 'Courier New' },
                              { value: 'Verdana, Geneva, sans-serif', name: 'Verdana' },
                              { value: "'Roboto', sans-serif", name: 'Roboto' },
                            ],
                          },
                          {
                            name: 'Text Decoration',
                            property: 'text-decoration',
                            type: 'select',
                            defaults: 'none',
                            options: [
                                { value: 'none', name: 'None' },
                                { value: 'underline', name: 'Underline' },
                                { value: 'overline', name: 'Overline' },
                                { value: 'line-through', name: 'Line-through' }
                            ]
                        }
                        ]
                    },
                    { name: 'Decorations', open: false, buildProps: ['border-radius-c', 'background-color', 'border-radius', 'border', 'box-shadow', 'background'] },
                    { name: 'Extra', open: false, buildProps: ['opacity'] },
                ],
            },
            panels: {
                defaults: [
                //   {
                //     id: 'options',
                //     buttons: [
                     
                //     ]
                //   },
                  {
                    id: 'views',
                    buttons: [
                      {
                            id: 'preview-page',
                            className: 'preview-page-button',
                            label: `
                            <span>Preview</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M1 11L11 1M11 1H4.33333M11 1V7.66667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            `,
                            attributes: { 
                                title: 'Preview Page'
                            },
                            command: 'preview-page'
                      },
                      {
                        id: 'undo',
                        className: 'fa fa-undo',
                        command: 'undo',
                        attributes: { title: 'Undo' }
                      },
                      {
                        id: 'redo',
                        className: 'fa fa-redo',
                        command: 'redo',
                        attributes: { title: 'Redo' }
                      },
                      {
                        id: 'open-sm',
                        className: 'fa fa-paint-brush',
                        command: 'open-sm',
                        active: true,
                        attributes: { title: 'Open Style Manager' }
                      },
                      {
                        id: 'open-tm',
                        className: 'fa fa-cog',
                        command: 'open-tm',
                        attributes: { title: 'Settings' }
                      },
                      {
                        id: 'open-blocks',
                        className: 'fa fa-th-large',
                        command: 'open-blocks',
                        attributes: { title: 'Open Blocks' }
                      },
                      {
                        active: true,
                        id: 'sw-visibility',
                        className: 'fa fa-square-o',
                        command: 'sw-visibility',
                        context: 'sw-visibility',
                        attributes: { title: 'View components' }
                      },
                        {
                            id: 'add-variable',
                            className: 'variable-dropdown',
                            command: 'add-variable',
                            attributes: { title: 'Add Variable' },
                            label: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 9V7M2 3V1M1 2H3M1 8H3M5.4 1.4L4.70633 3.20354C4.59352 3.49684 4.53712 3.64348 4.44941 3.76683C4.37168 3.87616 4.27616 3.97168 4.16683 4.04941C4.04348 4.13712 3.89684 4.19352 3.60354 4.30633L1.8 5L3.60355 5.69367C3.89684 5.80648 4.04348 5.86288 4.16683 5.95059C4.27616 6.02832 4.37168 6.12384 4.44941 6.23317C4.53712 6.35652 4.59352 6.50316 4.70633 6.79646L5.4 8.6L6.09367 6.79646C6.20648 6.50316 6.26288 6.35652 6.35059 6.23317C6.42832 6.12384 6.52384 6.02832 6.63317 5.95059C6.75652 5.86288 6.90316 5.80648 7.19646 5.69367L9 5L7.19646 4.30633C6.90316 4.19352 6.75652 4.13712 6.63317 4.04941C6.52384 3.97168 6.42832 3.87616 6.35059 3.76683C6.26288 3.64348 6.20648 3.49684 6.09367 3.20354L5.4 1.4Z" stroke="#213B7C" stroke-linecap="round" stroke-linejoin="round"/></svg>Add Variable',
                        }
                    ]
                  },
                ],
            },
            canvas: {
                styles: [
                    'body { background-color: #121212; }',
                    // 'img { width: 500px; height: auto; object-fit: contain; }' // Add this line
                ]
            },
        });

        editor.Commands.add('redo', {
            run(editor) {
                editor.UndoManager.redo();
            }
        });
        editor.Commands.add('undo', {
            run(editor) {
                editor.UndoManager.undo();
            }
        });
        editor.Commands.add('image-editor', {
            run(editor, sender, options = {}) {
                const imageComponent = options.target;
                if (imageComponent.get('type') === 'image') {
                    imageComponent.setStyle({
                        width: '500px',
                        height: 'auto',
                        'object-fit': 'contain'
                    });
                }
            }
        });
        
        // Listen for component add event
        // editor.on('component:add', (component) => {
        //     if (component.get('type') === 'image') {
        //         editor.runCommand('image-editor', { target: component });
        //     }
        // });
        // ['path', 'circle', 'rect', 'line', 'polyline', 'polygon'].forEach(type => {
        //     editor.DomComponents.addType(`svg-${type}`, {
        //       isComponent: el => el.tagName === type.toUpperCase() && el.parentNode.tagName === 'SVG',
        //       model: {
        //         defaults: {
        //           selectable: true,
        //           hoverable: true,
        //           draggable: false,
        //           traits: [
        //             {
        //               type: 'color',
        //               name: 'fill',
        //               label: 'Fill Color',
        //             },
        //             {
        //               type: 'color',
        //               name: 'stroke',
        //               label: 'Stroke Color',
        //             },
        //             {
        //               type: 'number',
        //               name: 'stroke-width',
        //               label: 'Stroke Width',
        //             },
        //           ],
        //         }
        //       }
        //     });
        //   });
        //   editor.on('component:selected', (component) => {
        //     if (!component.getStyle('font-family')) {
        //       component.addStyle({ 'font-family': 'GT Walsheim Pro, sans-serif' });
        //     }
        //   });
        // editor.on('component:mount', (component) => {
        //     if (!component.getStyle('font-family')) {
        //       component.addStyle({ 
        //         'font-family': productData?.branding?.font 
        //           ? JSON?.parse(productData?.branding?.font)?.value 
        //           : 'GT Walsheim Pro, sans-serif',
        //       });
        //     }
        //   });
        //   editor.StyleManager.addSector('svg', {
        //     name: 'SVG Style',
        //     open: false,
        //     properties: [
        //       {
        //         name: 'Fill',
        //         property: 'fill',
        //         type: 'color',
        //       },
        //       {
        //         name: 'Stroke',
        //         property: 'stroke',
        //         type: 'color',
        //       },
        //       {
        //         name: 'Stroke Width',
        //         property: 'stroke-width',
        //         type: 'number',
        //         units: ['px', 'em', '%'],
        //         defaults: 'px',
        //       },
        //     ]
        //   });
          
        //   editor.Commands.add('select-svg-elements', {
        //     run(editor) {
        //       const selected = editor.getSelected();
        //       if (selected && selected.get('tagName') === 'svg') {
        //         const children = selected.get('components').models;
        //         children.forEach(child => {
        //           child.set('selectable', true);
        //         });
        //       }
        //     }
        //   });
          
        //   editor.on('component:selected', model => {
        //     if (model.get('tagName') === 'svg') {
        //       editor.runCommand('select-svg-elements');
        //     }
        //   });
        handleLoad(editor);
        // editor.load();
        editor.on('canvas:frame:load:body', ({ window }) => {            
            const targetElement = window.document.querySelector('[data-gjs-type="wrapper"]');
            if (targetElement) {
                targetElement.style.width = '100%';
                targetElement.style.height = '100%';
                // targetElement.style.maxWidth = '100%';
                // targetElement.style.minWidth = '100%';
                const style = window.document.createElement('style');
                style.textContent = `
                    // body{
                    // background-color:#121212 !important;
                    // }
                    body::-webkit-scrollbar {
                    background-color:#fff;
                    width:16px
                    }
                    body::-webkit-scrollbar-track {
                    background-color:#fff
                    }
                    body::-webkit-scrollbar-track:hover {
                    background-color:#f4f4f4
                    }
                    body::-webkit-scrollbar-thumb {
                    background-color:#babac0;
                    border-radius:16px;
                    border:5px solid #fff
                    }
                    body::-webkit-scrollbar-thumb:hover {
                    background-color:#a0a0a5;
                    border:4px solid #f4f4f4
                    }
                    body::-webkit-scrollbar-button {display:none}`
                ;
                window.document.head.appendChild(style);
            }
        });
        editor.on('change:device', (value) => {
            if (value?.changed?.device == 'mobilePortrait' || value?.changed?.device == 'mobileLandscape') {
              editor.DomComponents.getWrapper().find('[data-gjs-type="default"]').forEach(block => {
                block.addStyle({ width: 'auto', minWidth: 'auto',maxWidth: 'auto' });
              });
            }
            // editor.DomComponents.getWrapper().find('iframe').forEach(iframe => {
            //     iframe.addStyle({
            //         width: '100%',     // Full width of container
            //         maxWidth: '100%',  // Ensure it doesn't overflow
            //         minWidth: '100%',  // Minimum width is full container
            //         height: 'auto',    // Maintain aspect ratio
            //         objectFit: 'contain' // Ensure content is fully visible
            //     });
            // });
        });

        editor.Commands.add('apply-style', {
            run: (editor, sender, options) => {
                const selectedComponent = editor.getSelected();
                if (selectedComponent) {
                    selectedComponent.addStyle({ [options.property]: options.value + ' !important' });
                }
            }
        });
        editor.on('styleManager:change', (view, property) => {
            if (property === 'font-size') {
                editor.runCommand('apply-style', {
                    property: 'font-size',
                    value: view.getInputValue() + 'px'
                });
            }
        });

        editor.on('component:selected', (component) => {
            component.set('resizable', {
                tl: true, // top left
                tr: true, // top right
                bl: true, // bottom left
                br: true, // bottom right
                tc: true, // top center
                bc: true, // bottom center
                cl: true, // center left
                cr: true  // center right
            });
            if (component.get('type') === 'div') {
                const contextMenu = editor.ContextMenu;
                if (contextMenu) {
                    contextMenu.update([
                        {
                            content: 'Add Inner Div',
                            command: 'add-inner-div'
                        }
                    ]);
                }
            }
        });
        editor.Commands.add('add-variable', {
            run(editor, sender) {
                sender.set('active', 0);

                const options = variables.map((val, index) =>
                    `<option key=${index} value="((${val}))">((${val}))</option>`
                ).join('');

                const modalContent = `
                        <div>
                            <div style="display:flex; gap:10px; align-items:center;">
                                <label for="custom-select" class="productlabels">Choose a Variable:</label>
                                <div class="gjs-field">
                                    <select id="custom-select">
                                        ${options}
                                    </select>
                                </div>
                            </div>
                            <div class="d-flex gap-2 mt-20px align-items-center justify-content-center">
                                <button type="button" class="fs-12 w-50 mt-0 integration-btns integration-btn-grey" id="cancel-btn">Cancel</button>
                                <button id="apply-btn" data-value="178" type="button" class="fs-12 w-50 shadow-none project-blue-btn">Save Changes</button>
                            </div>
                        </div>
                        `;
                const modal = editor.Modal;
                modal.setTitle('Add Custom Variable');
                modal.setContent(modalContent);
                modal.open();

                document.getElementById('apply-btn').onclick = () => {
                    const selectedValue = document.getElementById('custom-select').value;
                    const selected = editor.getSelected();
                    if (selected) {
                        const el = selected.view.$el;
                        if (el.length) {
                            // Ensure the element is an editable container
                            const canvasDoc = editor.Canvas.getBody().ownerDocument;
                            const selection = canvasDoc.defaultView.getSelection();

                            if (selection.rangeCount > 0) {
                                const range = selection.getRangeAt(0);
                                // Create a new span element
                                const span = canvasDoc.createElement('span');
                                span.className = 'custom-variable';
                                span.textContent = selectedValue;

                                // Clear any existing contents in the range
                                range.deleteContents();

                                // Create a DocumentFragment to ensure proper insertion
                                const fragment = canvasDoc.createDocumentFragment();
                                fragment.appendChild(span);

                                // Insert the fragment into the range
                                range.insertNode(fragment);

                                // Optionally, place the cursor after the inserted span
                                range.setStartAfter(span);
                                range.collapse(true);

                                selection.removeAllRanges();
                                selection.addRange(range);
                            }
                        }
                    }
                    modal.close();
                    handleSave();  // Ensure handleSave is called after the insertion
                };
                document.getElementById('cancel-btn').onclick = () => {
                    modal.close();
                };
            }
        });
        editor.BlockManager.add('navbar', {
            label: 'Navbar',
            media: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 14 12" fill="none"><rect x="0.5" width="13" height="12" rx="2" fill="#EEEDEE"/><rect x="0.5" width="13" height="5" rx="2" fill="#1188FF"/></svg>',
            attributes: { class: 'gjs-fonts gjs-f-navbar' },
            content: `
            <header style="color: #FFFFFF; background-color: #000 !important;box-shadow: 0px 4px 33px 0px rgba(0, 0, 0, 0.90); padding: 18px 37px 22px; background: #FFF; z-index: 999; position: sticky; display: flex; justify-content: space-between; width: 100%;">
                <div style="
                    display: inline-flex;
                    justify-content: space-between;
                    gap: 16px;
                    align-items: center;
                ">
                    <img data-subscriber-logo="true" src="https://dummyimage.com/150" alt="" height="45px">
                    <span data-subscriber-x='true'>X</span>
                    <img data-branding-logo='true' src="${productData?.branding ? productData?.branding?.logo : 'https://dummyimage.com/150'}" alt="" height="45px">
                </div>
                <div>
                    <a href="${productData?.button_url}" style=" background: ${productData?.branding ? productData?.branding?.brand_color : productData?.accent_theme} !important; color: #1E242A !important; display: inline-flex; padding: 15px 22px; justify-content: center; align-items: center; border-radius: 12px; background: #E7E7FF; border: none; text-align: center; font-size: 20px; font-style: normal; font-weight: 400;gap: 10px; line-height: 100%; text-decoration: none !important;">
                        ${productData?.buy_button_text ?? 'Book a Call'}
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M1 11L11 1M11 1H4.33333M11 1V7.66667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </a>
                </div>
            </header>`
        });
        editor.Commands.add('preview-page', {
            run: function(editor, sender) {
                window.open(protocol + '' + slug + '.' +pageUrl  + '/' +productSlug+`?iframe=1`, '_blank');
            }
        })
        // editor.Panels.addButton('options', [{
        //     id: 'add-variable',
        //     className: 'variable-dropdown',
        //     command: 'add-variable',
        //     attributes: { title: 'Add Variable' },
        //     label: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 9V7M2 3V1M1 2H3M1 8H3M5.4 1.4L4.70633 3.20354C4.59352 3.49684 4.53712 3.64348 4.44941 3.76683C4.37168 3.87616 4.27616 3.97168 4.16683 4.04941C4.04348 4.13712 3.89684 4.19352 3.60354 4.30633L1.8 5L3.60355 5.69367C3.89684 5.80648 4.04348 5.86288 4.16683 5.95059C4.27616 6.02832 4.37168 6.12384 4.44941 6.23317C4.53712 6.35652 4.59352 6.50316 4.70633 6.79646L5.4 8.6L6.09367 6.79646C6.20648 6.50316 6.26288 6.35652 6.35059 6.23317C6.42832 6.12384 6.52384 6.02832 6.63317 5.95059C6.75652 5.86288 6.90316 5.80648 7.19646 5.69367L9 5L7.19646 4.30633C6.90316 4.19352 6.75652 4.13712 6.63317 4.04941C6.52384 3.97168 6.42832 3.87616 6.35059 3.76683C6.26288 3.64348 6.20648 3.49684 6.09367 3.20354L5.4 1.4Z" stroke="#213B7C" stroke-linecap="round" stroke-linejoin="round"/></svg>Add Variable',
        // }]);
        editor.BlockManager.add('heroBlock', {
            label: 'Hero Section',
            media: '<svg xmlns="http://www.w3.org/2000/svg" width="58" height="17" viewBox="0 0 58 17" fill="none"><rect x="0.761963" y="17" width="17" height="17" rx="4" transform="rotate(-90 0.761963 17)" fill="#1188FF"/><rect x="20.6226" y="17" width="17" height="17" rx="4" transform="rotate(-90 20.6226 17)" fill="#1188FF"/><rect x="40.238" y="17" width="17" height="17" rx="4" transform="rotate(-90 40.238 17)" fill="#1188FF"/></svg>',
            attributes: { class: 'gjs-fonts gjs-f-hero' },
            content: `
            <div style="padding: 0 20px;">
            <div style="background-color: #121212; background-position: center; background-repeat: no-repeat; background-size: cover; width: 100%; display: flex; justify-content: center; padding-bottom: 82px; position: relative; overflow: hidden;">
                <div style="max-width: 1008px; margin-top: 106px;">
                    <span style="display:block;text-align: center; font-size: 75px; font-weight: 500;color: #EEECE8;"><span style="custom-variable">((company_name))</span> 's marketing data into strategic resources.</span>
                    <span style="display:block;color: #FFFFFF; text-align: center; font-size: 22px; font-weight: 500; max-width: 637px; margin: 0 auto; margin-top: 35px;">We have designed this page for you to show you how <span style="custom-variable">((lead_first_name))</span> could definitively automate its data processing to focus solely on improving performance. Are you interested?</span>
                    <div style=" width: 100%; display: flex; justify-content: center; align-items: center; gap: 6px; margin-top: 43px; ">
                        <a href="${productData?.button_url}" style=" background: ${productData?.branding ? productData?.branding?.brand_color : productData?.accent_theme} !important; color: #1E242A !important; display: inline-flex; padding: 15px 22px; justify-content: center; align-items: center; border-radius: 12px; background: #E7E7FF; border: none; text-align: center; font-size: 20px; font-style: normal; font-weight: 400;gap: 10px; line-height: 100%; text-decoration: none !important;">
                            ${productData?.buy_button_text ?? 'Book a Call'}
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M1 11L11 1M11 1H4.33333M11 1V7.66667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
            <div style="width: 100%; background-color: #121212; min-height: 450px; display: flex; justify-content: center;position: relative;margin-bottom: 6rem;">
                <iframe style=" width: 100%; max-width: 1018px; height: 500px; border-radius: 43px !important;position: absolute;background: #ddd; filter: drop-shadow(0 0 15px #00000073); z-index: 1;" src="https://www.youtube.com/embed/2k9EMNjFoaU" frameborder="0" allow="autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
                <div style="width: 100%; overflow: hidden; border-radius: 0 0 27px 27px; display: flex; flex-direction: column; justify-content: flex-end;">
                    <div style="background: linear-gradient(180deg, ${productData?.branding ? productData?.branding?.brand_color : productData?.accent_theme}  0.06%, ${productData?.branding ? productData?.branding?.brand_color : productData?.accent_theme} 76.17%);border-top-left-radius: 20%; filter: blur(15px); width: -webkit-fill-available; height: 375px; border-top-right-radius: 20%;"></div>
                </div>
            </div>
            <div>
            
            `
        });
        editor.BlockManager.add('horizontalBlock', {
            label: 'Horizontal Section',
            attributes: { class: 'gjs-fonts gjs-f-horizontal' },
            media: '<svg xmlns="http://www.w3.org/2000/svg" width="42" height="21" viewBox="0 0 42 21" fill="none"><rect x="20" y="20.5" width="20" height="20" rx="5" transform="rotate(180 20 20.5)" fill="#1188FF"/><rect x="42" y="20.5" width="20" height="20" rx="5" transform="rotate(180 42 20.5)" fill="#1188FF"/></svg>',
            content: `
                <div style="background-color: #121212;display:flex;justify-content:center;padding:1rem;">
                    <div style="border-radius: 40px;color: #FFFFFF; margin-top: 30px !important; max-width: 1300px; width: 100%; overflow: hidden;flex-wrap:wrap; display: flex; padding: 30px; gap: 30px; align-items: center; justify-content: space-between;">
                        <div style="max-width: 550px;">
                            <div style="color: #EEECE8;font-size: 35px; font-weight: 500; text-align: start;">100% Customizable Dashboards for <span style="custom-variable">((lead_first_name))</span></div>
                            <div style="color: #727272; text-align: start; font-size: 21px; font-weight: 400; margin-top: 17px;">Create customizable dashboards in one click with an intuitive interface accessible to all. With 650+ No Code connectors, track your KPIs, performance in real time and compare your advertising results.</div>
                            <a style="display: flex;cursor:pointer; align-items: center;margin-top: 17px; width:154px; justify-content: space-between; color: #FF1451; font-size: 30px; font-weight: 500;  /* 34.23px */ gap: 10px; cursor: pointer;">
                                ${productData?.buy_button_text ?? 'Book a Call'}
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                    <path d="M2 18.5L19 1.5M19 1.5H7.66667M19 1.5V12.8333" stroke="#FF1451" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                            </a>
                        </div>
                        <div style="display: flex; justify-content: center; align-items: center; overflow: hidden; box-shadow: 0px 0px 20px 3px #635f5f; position: relative; max-width: 620px; width: 100%; min-height: 600px;">
                            <img style="max-width: 620px;width: 100%;position: relative;filter: blur(15px);height: 600px;" src="https://dummyimage.com/620" alt="">
                            <img style="max-width: 535px;width: 100%;height: 333px;position: absolute;z-index: 0;" src="https://dummyimage.com/333" alt="">
                        </div>
                    </div>
                </div>`
        });
        editor.BlockManager.add('verticalBlock', {
            label: 'Vertical Section',
            attributes: { class: 'gjs-fonts gjs-f-vertical' },
            media:'<svg xmlns="http://www.w3.org/2000/svg" width="40" height="23" viewBox="0 0 40 23" fill="none"><rect x="40" y="10.5" width="40" height="10" rx="5" transform="rotate(180 40 10.5)" fill="#1188FF"/><rect x="40" y="22.5" width="40" height="10" rx="5" transform="rotate(180 40 22.5)" fill="#1188FF"/></svg>',
            content: `
                <div style="background-color: #121212; display:flex;justify-content:center;padding:1rem;">
                    <div style="color: #FFFFFF; margin-top: 30px !important; max-width: 1300px; width: 100%; overflow: hidden; display: flex; flex-direction: column; justify-content: center; padding-top: 40px; gap: 50px; align-items: center;">
                        <div>
                            <div style="color: #EEECE8; max-width: 800px; width: 100%; font-size: 35px; font-weight: 500;">AI at the service of <span style="custom-variable">((lead_first_name))</span> with AdGen AI</div>
                            <div style="max-width: 800px; width: 100%; font-size: 21px; font-weight: 500; margin-top: 18px;">AdGen AI, our generative AI ad generation solution, lets you create, test, and serve ads at scale in seconds.</div>
                        </div>
                        <div>
                            <img src="https://dummyimage.com/470" alt="">
                        </div>
                    </div>
                </div>`
        });
        editor.BlockManager.add('largeTextBlock', {
            label: 'Large Text Section',
            media:'<svg xmlns="http://www.w3.org/2000/svg" width="40" height="13" viewBox="0 0 40 13" fill="none"><rect width="40" height="13" rx="5" fill="#1188FF"/></svg>',
            attributes: { class: 'gjs-fonts gjs-f-large-text' },
            content: `
            <div style=" min-height: 700px; display: flex; justify-content: center; align-items: center; /* text-align: center; */ flex-direction: column; gap: 30px; background-color: #ffffff;">
                <span style="text-align: center; font-size: 70px; font-weight: 400; text-align: center; line-height: 1.3; max-width: 1000px;">
                    10x your outreach replies, meetings booked and sales.
                </span>
                <span style="text-align: center; color: #959595; font-size: 26px; font-weight: 500;  /* 34.06px */ max-width: 750px;">
                    Hey <span class="custom-variable">((lead_first_name))</span>
                    ! Made this quick landing page showing how we can help scale Testimonial.
                </span>
                <a style="display: flex;cursor:pointer; align-items: center; width:154px; justify-content: space-between; color: #FF1451; font-size: 30px; font-weight: 500;  /* 34.23px */ gap: 10px; cursor: pointer;">
                    ${productData?.buy_button_text ?? 'Book a Call'}
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                        <path d="M2 18.5L19 1.5M19 1.5H7.66667M19 1.5V12.8333" stroke="#FF1451" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </a>
            </div>
            `
        });
        editor.BlockManager.add('logoBlock', {
            label: 'Logo Section',
            attributes: { class: 'gjs-fonts gjs-f-logo' },
            media:'<svg xmlns="http://www.w3.org/2000/svg" width="44" height="5" viewBox="0 0 44 5" fill="none"><rect x="0" width="10" height="5" rx="2.5" fill="#1188FF"/><rect x="11" width="10" height="5" rx="2.5" fill="#1188FF"/><rect x="22" width="10" height="5" rx="2.5" fill="#1188FF"/><rect x="33" width="10" height="5" rx="2.5" fill="#1188FF"/></svg>',
            content: `
           <div style=" width: 100%; background-color: ${productData?.branding ? productData?.branding?.brand_color : productData?.accent_theme}; display: flex; justify-content: center; align-items: center; gap: 41px; flex-direction: column; min-height: 292px;">
                <span style="display:block; text-align: center; font-size: 35px; font-weight: 500;">Join the 6,300+ teams using Adriel to boost their marketing performance and automate their strategy with AI.</span>
                <div style="display:flex; gap:16px; justify-content:center;flex-wrap:wrap;">
                    <img style="border-radius: 11px;min-width:124px;" src="https://dummyimage.com/124" alt="" height="48px">
                    <img style="border-radius: 11px;min-width:124px;" src="https://dummyimage.com/124" alt="" height="48px">
                    <img style="border-radius: 11px;min-width:124px;" src="https://dummyimage.com/124" alt="" height="48px">
                    <img style="border-radius: 11px;min-width:124px;" src="https://dummyimage.com/124" alt="" height="48px">
                    <img style="border-radius: 11px;min-width:124px;" src="https://dummyimage.com/124" alt="" height="48px">
                    <img style="border-radius: 11px;min-width:124px;" src="https://dummyimage.com/124" alt="" height="48px">
                </div>
            </div>`
        });
        editor.BlockManager.add('linkBlock', {
            label: 'Link',
            content: `
            <div style="background-color: #121212;">
                <span style="margin-right:5px;">My link</span>
                <a href="#" title="Click me">Click me</a>
            </div>
            `,
            category: 'Extra',
            media : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="#1188ff" d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"/></svg>',
            attributes: { class: 'gjs-fonts gjs-f-button gjs-f-link' },
        });
        editor.BlockManager.add('reviewBlock', {
            label: 'Reviews Section',
            attributes: { class: 'gjs-fonts gjs-f-review' },
            media:'<svg xmlns="http://www.w3.org/2000/svg" width="50" height="21" viewBox="0 0 50 21" fill="none"><rect x="12.5" y="17" width="12" height="13" rx="5" transform="rotate(180 12.5 17)" fill="#1188FF"/><rect x="34.5" y="20.5" width="20" height="20" rx="5" transform="rotate(180 34.5 20.5)" fill="#1188FF"/><rect x="49.5" y="17" width="13" height="13" rx="5" transform="rotate(180 49.5 17)" fill="#1188FF"/></svg>',
            content: `
                <div style="background-color: #121212; display:flex;justify-content:center;padding:1rem;">
                    <div style="color: #FFFFFF; margin-top: 30px !important; width: 100%; overflow: hidden; display: flex; flex-direction: column; justify-content: center; align-items: flex-start;">
                       <div style="font-size: 35px;font-weight: 500;line-height: 1.3;text-align: center;width:100%;">What our trailblazing customers are saying:</div>
                            <div style="display: flex;justify-content: center; gap: 12px; width: 100%;flex-wrap: wrap;">
                                <div style="background-color: #121212;border-radius: 20px; display: flex; max-width: 406px; min-height: 375px; width: 100%; padding: 50px 25px; flex-direction: column; align-items: flex-start; gap: 30px; text-align: start !important;">
                                    <div style="display: flex; align-items: center; gap: 13px;">
                                        <div>
                                            <img style="width: 75px; height: 75px; border-radius: 100%; overflow: hidden; object-fit: cover;" src="https://images.genpage.ai/public/d0bfc6aa351acc72a0d541e94ea5a61baddad11e231b087f749a.png" width="75px" alt="">
                                        </div>
                                        <div>
                                            <span>Tim Cook</span>
                                            <p style="font-weight:400;">CEO @ Apple</p>
                                        </div>
                                    </div>
                                    <p style="color: #EEECE8; font-size: 22px; font-weight: 600; line-height: 1.3;">[Company Name] is an absolute game changer for [GPT generated content about feature].</p>
                                </div>
                                 <div style="background-color: #121212;border-radius: 20px; display: flex; max-width: 406px; min-height: 375px; width: 100%; padding: 50px 25px; flex-direction: column; align-items: flex-start; gap: 30px; text-align: start !important;">
                                    <div style="display: flex; align-items: center; gap: 13px;">
                                        <div>
                                            <img style="width: 75px; height: 75px; border-radius: 100%; overflow: hidden; object-fit: cover;" src="https://images.genpage.ai/public/d613194350d02fb46e3645324476bb6daf49c8ad83de2819327f.png" width="75px" alt="">
                                        </div>
                                        <div>
                                            <span>Jeff Bezos</span>
                                            <p style="font-weight:400;">Executive Chairman @ Amazon</p>
                                        </div>
                                    </div>
                                    <p style="color: #EEECE8; font-size: 22px; font-weight: 600; line-height: 1.3;">[Company Name] is so cool! They've allowed us to [GPT generated content about benefit of feature]</p>
                                </div>
                                 <div style="background-color: #121212;border-radius: 20px; display: flex; max-width: 406px; min-height: 375px; width: 100%; padding: 50px 25px; flex-direction: column; align-items: flex-start; gap: 30px; text-align: start !important;">
                                    <div style="display: flex; align-items: center; gap: 13px;">
                                        <div>
                                            <img style="width: 75px; height: 75px; border-radius: 100%; overflow: hidden; object-fit: cover;" src="https://images.genpage.ai/public/ec92520156aff139ca4145524740b45fa0ddaca8d6390528dcfe.png" width="75px" alt="">
                                        </div>
                                        <div>
                                            <span>Safra Catz</span>
                                            <p style="font-weight:400;">CEO @ Oracle</p>
                                        </div>
                                    </div>
                                    <p style="color: #EEECE8; font-size: 22px; font-weight: 600; line-height: 1.3;">We're beyond happy with the performance of [Company Name] for our [GPT generated content about use case].</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>`
        });

        editor.BlockManager.add('footerBlock', {
            label: 'Footer Section',
            attributes: { class: 'gjs-fonts gjs-f-footer' },
            media: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 14 12" fill="none"><rect x="13.5" y="12" width="13" height="12" rx="2" transform="rotate(-180 13.5 12)" fill="#EEEDEE"/><rect x="13.5" y="12" width="13" height="5" rx="2" transform="rotate(-180 13.5 12)" fill="#1188FF"/></svg>',
            content: `
               <div class="footer-section" style="padding: 40px; gap: 86px; display: flex; flex-direction: column; background: white;">
                    <div style="display: flex;flex-wrap:wrap;justify-content: space-between;align-items: center;background: ${productData?.branding ? productData?.branding?.brand_color : productData?.accent_theme};width: 100%;padding: 80px 118px 92px 70px;border-radius: 25px;">
                        <span style="width: 712px;text-align: left;color: #FFF;font-size: 60px;font-style: normal;/* font-weight: 400; *//* line-height: 106.1%; */">We’re here to help you grow Testimonial.</span>
                        <a href="${productData?.button_url}" style=" display: inline-flex; height: 40px; padding: 15px 22px; justify-content: center; align-items: center; gap: 10px; border-radius: 12px; background: #fff; color: ${productData?.branding ? productData?.branding?.brand_color : productData?.accent_theme};cursor:pointer;">
                            ${productData?.buy_button_text ?? 'Book a Call'}
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M1 11L11 1M11 1H4.33333M11 1V7.66667" stroke="${productData?.branding ? productData?.branding?.brand_color : productData?.accent_theme}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </a>
                    </div>
                    <div style=" width: 100%; display: flex; justify-content: space-between;">
                            <span>
                                <img src="${productData?.logo}" style=" width: 134px; height: 40px;">
                            </span>
                            <span style=" display: flex; align-items: center; gap: 9px;">
                                <a href="https://linkedin.com/in/" style="cursor:pointer;background: #F1F1F1; display:flex; align-items: center; justify-content: center; border-radius: 100%; height: 50px; width: 50px;">
                                    <div>
                                        <svg width=\"35px\" height=\"22px\" viewBox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xml:space=\"preserve\" xmlns:serif=\"http://www.serif.com/\" id=\"i0xfa\">
                                            <g><path d=\"M0,10C0,12.689 0.032,14.03 0.41,15.111C0.41,15.111 0.41,15.111 0.41,15.111C1.143,17.208 2.792,18.857 4.889,19.59C4.889,19.59 4.889,19.59 4.889,19.59C5.97,19.968 7.311,20 10,20C12.689,20 14.03,19.968 15.111,19.59C15.111,19.59 15.111,19.59 15.111,19.59C17.208,18.857 18.857,17.208 19.59,15.111C19.59,15.111 19.59,15.111 19.59,15.111C19.968,14.03 20,12.689 20,10C20,7.311 19.968,5.97 19.59,4.889C19.59,4.889 19.59,4.889 19.59,4.889C18.857,2.792 17.208,1.143 15.111,0.41C15.111,0.41 15.111,0.41 15.111,0.41C14.03,0.032 12.689,0 10,0C7.311,0 5.97,0.032 4.889,0.41C2.792,1.143 1.143,2.792 0.41,4.889C0.032,5.97 0,7.311 0,10ZM2,10C2,7.661 1.968,6.49 2.297,5.55C2.297,5.55 2.297,5.55 2.297,5.55C2.83,4.027 4.027,2.83 5.55,2.297C5.55,2.297 5.55,2.297 5.55,2.297C6.49,1.968 7.661,2 10,2C12.339,2 13.51,1.968 14.45,2.297C15.973,2.83 17.17,4.027 17.703,5.55C18.032,6.49 18,7.661 18,10C18,12.339 18.032,13.51 17.703,14.451C17.17,15.973 15.973,17.17 14.451,17.703C13.51,18.032 12.339,18 10,18C7.661,18 6.49,18.032 5.55,17.703C4.027,17.17 2.83,15.973 2.297,14.451C1.968,13.51 2,12.339 2,10ZM5,9L5,14C5,14.552 5.448,15 6,15C6.552,15 7,14.552 7,14L7,9C7,8.448 6.552,8 6,8C5.448,8 5,8.448 5,9ZM8.004,10.091C8.001,10.137 8,10.183 8,10.23C8,10.23 8,14 8,14C8,14.552 8.448,15 9,15C9.552,15 10,14.552 10,14L10,10.23C10,9.991 10.168,9.786 10.402,9.739L11.804,9.459C12.423,9.335 13,9.809 13,10.44L13,14C13,14.552 13.448,15 14,15C14.552,15 15,14.552 15,14L15,10.44C15,8.546 13.268,7.127 11.412,7.498L10.01,7.778L9.977,7.786C9.879,7.337 9.478,7 9,7C8.448,7 8,7.448 8,8L8,10C8,10.031 8.001,10.061 8.004,10.091Z\" id=\"i9x7h\"></path><g transform=\"matrix(1,0,0,1,-0.183389,-0.0938969)\"><circle cx=\"6.212\" cy=\"6.377\" r=\"0.987\" id=\"i6bfg\"></circle></g></g>
                                        </svg>
                                    </div>
                                </a>
                                <a href="https://instagram.com" style="cursor:pointer; background: #F1F1F1; display:flex; align-items: center; justify-content: center; border-radius: 100%;height: 50px;width: 50px;">
                                   <div>
                                        <img width=\"35px\" height=\"22px\" src=\"https://static.cdninstagram.com/rsrc.php/v4/yI/r/VsNE-OHk_8a.png\"/>
                                    </div>
                                </a>
                                <a href="https://x.com/" style="cursor:pointer; background: #F1F1F1; display:flex; align-items: center; justify-content: center; border-radius: 100%; height: 50px; width: 50px;">
                                    <div>
                                       <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-twitter-x\" viewBox=\"0 0 16 16\">
                                        <path fill=\"black\" d=\"M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z\"/>
                                    </svg>
                                    </div>
                                </a>
                            </span>
                        </div>
                    </div>`
        });
        editor.BlockManager.add('textBlock', {
            label: 'Text Section',
            attributes: { class: 'gjs-fonts gjs-f-text' },
            content: `<span>
                          Add Text Here
                        </span>`
        });
        editor.BlockManager.add('iframeBlock', {
            label: 'Iframe Block',
            content: `
            <div style="width: 100%; background-color: #121212; min-height: 557px; display: flex; justify-content: center;">
                <iframe style=" width: 100%; max-width: 1018px; height: 585px; border-radius: 43px !important; margin-top: -13rem; z-index: 1;" src="https://www.youtube.com/embed/2k9EMNjFoaU" frameborder="0" allow="autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
            </div>
            `
        });
        editor.BlockManager.add('customImageBlock', {
            id: 'custom-image',
            label: 'Custom Image Block',
            content: `
                <div style="padding: 20px; text-align: center;">
                    <img src="https://dummyimage.com/150" alt="Placeholder Image" style="max-width: 100%; height: auto;" />
                    <p>Custom Image Block</p>
                </div>
            `,
            activate: true,
        });
        editor.BlockManager.add('imageBlock', {
            id: 'image',
            label: 'Image',
            content: { type: 'image' },
            activate: true,
        });

        editor.BlockManager.add('buttonBlock', {
            label: 'Button',
            attributes: { class: 'gjs-fonts gjs-f-button' },
            content: `
                <div style="padding: 10px; text-align: center;">
                    <a href="" style="padding: 10px 20px; background: #007bff; color: #fff; border: none; border-radius: 5px; cursor:pointer">Default Button Text</a>
                </div>
            `,
            activate: true,
        });
        editor.BlockManager.add('DivTag', {
            label: 'Add Div',
            attributes: { class: 'gjs-fonts gjs-f-div' },
            content: {
                type: 'div',
                style: { 
                    // padding: '10px', 
                    // margin: '10px', 
                    'height': '50px',
                    // 'width' : '100%',
                    border: '1px solid #ccc'
                },
                // components: [
                //     {
                //         type: 'text',
                //         content: ''
                //     }
                // ]
            }
        });
        editor.Commands.add('add-inner-div', {
            run(editor, sender) {
                const selectedComponent = editor.getSelected();
                if (selectedComponent && selectedComponent.get('type') === 'div') {
                    const innerDiv = {
                        type: 'div',
                        classes: ['custom-div'],
                        style: { 
                            padding: '10px', 
                            margin: '10px', 
                            'height': '50px',
                            border: '1px solid #ccc'
                        },
                        components: [
                            {
                                type: 'text',
                                content: 'Inner Div'
                            }
                        ]
                    };
                    selectedComponent.append(innerDiv);
                }
            }
        });
        editor.Commands.add('add-font', {
            run(editor, sender, options = {}) {
              const fontName = prompt('Enter font name:');
              const fontUrl = prompt('Enter font URL:');
              
              if (fontName && fontUrl) {
                // Add font to document
                const style = document.createElement('style');
                style.textContent = `
                  @import url('${fontUrl}');
                  .font-${fontName.replace(/\s+/g, '-').toLowerCase()} {
                    font-family: "${fontName}";
                  }
                `;
                document.head.appendChild(style);
                
                // Add font to font selector
                const fontProperty = editor.StyleManager.getProperty('Typography', 'font-family');
                fontProperty.addOption({ value: `"${fontName}", sans-serif`, name: fontName });
              }
            }
          });
          
          // Add a button to trigger the command
          editor.Panels.addButton('options', {
            id: 'add-font',
            className: 'fa fa-font',
            command: 'add-font',
            attributes: { title: 'Add Font' }
          });
        editorRef.current = editor;

        return () => {
            editor.destroy();
        };
    }, [campaign_id]);

    const handleSave = () => {
        const editor = editorRef.current;
        const html = editor.getHtml();
        const css = editor.getCss();
        const formData = new FormData();
        const data = JSON.stringify({ html, css });
        formData.append("project", slug);
        formData.append("product_id", campaign_id);
        formData.append("data", data);
        fetch(`${apiUrl}/page-builder/store`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            },
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                if (data?.status_code == 200) {
                    console.log('Page saved successfully!');
                }
            })
            .catch(error => console.error('Error saving page:', error));
    };
    const handleLoad = async (editor) => {
        if (slug) {
            try {
                const response = await fetch(`${apiUrl}/page-builder/load/${slug}/${campaign_id}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem("token")}`
                    },
                });

                const data = await response.json();

                if (data?.status_code === 200) {
                    const { html, css } = data.data?.builder_data;
                    editor.setComponents(html);
                    editor.setStyle(css);
                } else {
                    toast.error(data?.status_message);
                }
            } catch (error) {
                console.error('Error loading page:', error);
            }
        }
    };
    return (
        <>
        {/* <div id="wrapper">
            <PageHeader/> */}
            <div id="gjs">
                <div className="panel">
                </div>
            </div>
                <div class="panel__left">
                    <span className='layer-manager-title'>Template</span>
                    {creditsUsageJSX()}
                </div>
            {/* <div id="blocks"></div>
            <div id="blocks"></div>
            
            <div class="panel__right"></div> */}
            {/* <button className='save-button' onClick={handleSave}>Save</button> */}
        {/* </div> */}
        <link href="https://fonts.googleapis.com/css2?family=Open+Sans&family=Roboto&family=Lato&display=swap" rel="stylesheet"/>
        </>
    );
};

export default GrapeJs;